import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/429.tsx';
defineClientComponent('429', Component);